import cartIcon from "@assets/images/cart-white.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage } from "react-intl";

interface BottomBarProps {
  selectedLine: number;
  disabled?: boolean;
  onClear: () => void;
  onAddToCart: () => void;
  onCreateNow: () => void;
}

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  () => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9,
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)"
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    ml_20: {
      marginLeft: "2rem"
    },
    icon: {
      marginRight: "1.1rem"
    },
    textButton: {
      fontSize: "1.8rem",
      lineHeight: "24px",
      fontWeight: 400
    },
    btnCustom: {
      minWidth: "15.6rem"
    }
  }),
  { name: "BottomBar" }
);

const BottomBar: React.FC<BottomBarProps> = props => {
  const { selectedLine, onClear, onAddToCart, onCreateNow, disabled } = props;
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });

  return (
    <div className={classes.bottomBar}>
      <MyTypography variant="body2">
        เลือก <b>{selectedLine}</b> รายการ
      </MyTypography>
      <div className={classes.barRight}>
        <div>
          <Button
            id="clearItem"
            className={classes.btnCustom}
            variant={"outlined"}
            color={"secondary"}
            onClick={onClear}
            disabled={disabled}
          >
            <span className={classes.textButton}>
              <FormattedMessage defaultMessage={"Clear"} />
            </span>
          </Button>
        </div>
        <div className={classes.ml_20}>
          <Button
            id="createNow"
            className={classes.btnCustom}
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onCreateNow}
          >
            <span className={classes.textButton}>
              <FormattedMessage defaultMessage={"Create Now"} />
            </span>
          </Button>
        </div>
        <div className={classes.ml_20}>
          <Button
            id="addToCart"
            className={classes.btnCustom}
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onAddToCart}
          >
            <img className={classes.icon} src={cartIcon} alt={"icon"} />
            <span className={classes.textButton}>
              <FormattedMessage defaultMessage={"Add to cart"} />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
